// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3O4Pq","header":"ReportDetails_header__1hwS8","title":"ReportDetails_title__2ssiA","left":"ReportDetails_left__2P_bX"};